import type { PipelineApiError } from '@/lib/api/pipelines.ts'

export function saveErrorKey(error: PipelineApiError): string {
  if (error.kind === 'unauthorized') return 'pages.managers.errorUnauthorized'
  if (error.kind === 'network') return 'pages.managers.errorNetwork'
  return 'pages.managers.errorGeneric'
}
